import React, { type ReactNode } from 'react';
import { t } from 'i18next';
import { Toast, ToastProvider, ToastViewport } from '@datanomik/core-ui';

const TONE = {
  success: 'success',
  error: 'destructive',
  warning: 'warning',
  info: 'info',
};

const renderMessage = (message) => {
  if (React.isValidElement(message)) return message;
  if (typeof message === 'string') return t(message);
  if (message && typeof message === 'object') {
    return (
      <>
        {message.message && <span>{t(message.message)}</span>}
        {message.details?.map((d, i) => (
          <span key={i} className="mt-0.5 block opacity-85">{t(d)}</span>
        ))}
      </>
    );
  }
  return null;
};

const messageTitle = (message, title) => {
  if (title) return t(title);
  if (message && typeof message === 'object' && !React.isValidElement(message) && message.title) {
    return t(message.title);
  }
  return undefined;
};
interface AlertMessageProps {
  openAlert: boolean;
  closeAlert: (...args: any[]) => any;
  alertMessage: string | Record<string, any> | ReactNode;
  alertSeverity: string;
  alertTitle?: string;
  snackbarProps?: Record<string, any>;
}

const AlertMessage = ({
  alertMessage, openAlert, alertSeverity, closeAlert, alertTitle, snackbarProps,
}: AlertMessageProps) => (
  <ToastProvider swipeDirection="right">
    <Toast
      open={openAlert}
      onOpenChange={(next) => { if (!next) closeAlert(); }}
      tone={TONE[alertSeverity] ?? 'info'}
      duration={snackbarProps?.autoHideDuration ?? 3000}
      title={messageTitle(alertMessage, alertTitle)}
      description={renderMessage(alertMessage)}
    />
    <ToastViewport />
  </ToastProvider>
);
export default AlertMessage;
